import { PrintConfirmationDialog, PrintConfirmationDialogWrapperProps } from './PrintConfirmationDialog';
import { useIptorTranslation } from '@iptor/base';

export const SalesOrderConfirmation = ({
  open,
  handleClose,
  selectedRows,
  onSuccess,
}: PrintConfirmationDialogWrapperProps) => {
  const { t } = useIptorTranslation();
  return (
    <PrintConfirmationDialog
      open={open}
      handleClose={handleClose}
      title={t('sales_orders:SalesOrderConfirmation')}
      selectedRows={selectedRows || []}
      documentType={'orderConfirmation'}
      onSuccess={onSuccess}
    />
  );
};
